<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['order.no']" :placeholder="refundable?$t('placeholder.returnOrderNo'):$t('placeholder.receiptOrderNo')" class="query" @pressEnter="search()" @search="search()"/>
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storerName')" allowClear class="query" @change="search()">
        <a-select-option v-for="d in storerData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-click="({row})=>rowClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :title="refundable?'business.label.returnOrderNo':'business.label.receiptOrderNo'" field="order.no"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="asnOrder.orderStatus" title="business.label.orderStatus" width="100">
        <template slot-scope="{ row }">{{orderStatusData.length === 0 ? row.asnOrder.orderStatus : orderStatusData.find(item => item.ordinal === row.asnOrder.orderStatus).name}}</template>
      </vxe-column>
      <vxe-column :title="refundable?'business.label.returnType':'business.label.receivingType'" field="orderType.name"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import moment from 'moment'
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ReceiptOrder',
  data() {
    return {
      data: [],
      page: 1,
      size: 5,
      contentSize: 0,
      loading: false,
      query: {
        'order.no': '',
        'storer.id': undefined,
        'refundable': this.refundable,
        'asnOrderStatusRange': { 'start': 'SUBMITTED', 'end': 'INSPECTING' }
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.225)
    }
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    },
    orderStatusData: {
      type: Array,
      default: []
    },
    storerData: {
      type: Array,
      default: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    moment,
    search() {
      this.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('receivingReceiptListFactory', this.query, this.page, this.size)
        .then((res) => {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
            this.rowClick(this.data[0])
          }
        }).finally(() => {
        this.loading = false
      })
    },
    rowClick(row) {
      this.$emit('rowClick', row.order.id)
    },
    reset() {
      this.query['order.no'] = ''
      this.query['storer.id'] = undefined
      this.getData()
    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>